import { useQuery } from '@tanstack/react-query'

import useAuth from 'hooks/useAuth'
import axiosServices from 'utils/axios'

import { QUERY_STALE_TIME_DEFAULT } from './constants'

export interface UserDownload {
  id: number
  file_name: string
  file_path: string
  status: 'pending' | 'completed' | 'failed'
  created_at: string
  updated_at: string
  user_id: number
  business_id: number
  download_url: string
  seen: boolean
}

const fetchUserDownloads = async (businessId: number | undefined): Promise<UserDownload[]> => {
  const response = await axiosServices.get(`/businesses/${businessId}/user_downloads/query`)
  return response.data
}

export const useFetchUserDownloads = () => {
  const { user } = useAuth()

  return useQuery({
    queryKey: ['fetch-user-downloads', user?.business_id],
    queryFn: () => fetchUserDownloads(user?.business_id),
    staleTime: QUERY_STALE_TIME_DEFAULT,
    refetchInterval: (query) => {
      const {
        state: { data }
      } = query

      if (data?.some((download: UserDownload) => download.status === 'pending')) {
        return 5000
      }

      return false
    }
  })
}
